import { render, staticRenderFns } from "./color-button.vue?vue&type=template&id=31dd0c84&"
import script from "./color-button.vue?vue&type=script&lang=js&"
export * from "./color-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports